import { IJxtTreeNode } from './types';

/** Collect enabled (non-disabled) descendant leaf values under a branch node. */
function getEnabledLeafValues(node: IJxtTreeNode): string[] {
  if (!node.children?.length) return node.disabled ? [] : [node.value];
  return node.children.flatMap(getEnabledLeafValues);
}

/** Compute the checked state for a node given the current checked array. */
export function getCheckedState(node: IJxtTreeNode, checked: string[]): boolean | 'indeterminate' {
  if (!node.children?.length) return checked.includes(node.value);
  const leaves = getEnabledLeafValues(node);
  if (leaves.length === 0) return false;
  const allChecked = leaves.every((v) => checked.includes(v));
  const someChecked = leaves.some((v) => checked.includes(v));
  return allChecked ? true : someChecked ? 'indeterminate' : false;
}

/** Return the new checked array after toggling a node. */
export function toggleNode(node: IJxtTreeNode, checked: string[]): string[] {
  if (!node.children?.length) {
    if (node.disabled) return checked;
    return checked.includes(node.value) ? checked.filter((v) => v !== node.value) : [...checked, node.value];
  }
  // Branch: toggle only enabled (non-disabled) descendants
  const leaves = getEnabledLeafValues(node);
  if (leaves.length === 0) return checked;
  const allChecked = leaves.every((v) => checked.includes(v));
  if (allChecked) {
    return checked.filter((v) => !leaves.includes(v));
  }
  const toAdd = leaves.filter((v) => !checked.includes(v));
  return [...checked, ...toAdd];
}
